// extracted by mini-css-extract-plugin
module.exports = {"subHeader":"styles_subHeader__22xh9","button":"styles_button__1e-FT"};